import { ScheduleTypeEnum } from 'constants-visitor-management';

const getTimeOfDayMs = (date: Date): number =>
  ((date.getUTCHours() * 60 + date.getUTCMinutes()) * 60 +
    date.getUTCSeconds()) *
    1000 +
  date.getUTCMilliseconds();

export const validateVisitorScheduleRange = (interaction: {
  features: {
    VisitorManagement?: {
      schedule?: {
        type?: string;
        isAllDay?: boolean;
        startDate?: Date;
        endDate?: Date;
      };
    };
  };
}) => {
  const schedule = interaction?.features?.VisitorManagement?.schedule;

  if (schedule?.isAllDay) {
    return true;
  }

  if (!schedule?.startDate || !schedule?.endDate) return false;

  // DateRange/Repeat/CustomDates schedules generate one pass per day using
  // the start/end time of day, independent of how many calendar days apart
  // startDate/endDate are - so an equal (or reversed) time of day produces
  // a zero-duration pass on every occurrence, even though the raw
  // startDate/endDate instants themselves are valid (start < end).
  if (
    schedule.type === ScheduleTypeEnum.DateRange ||
    schedule.type === ScheduleTypeEnum.Repeat ||
    schedule.type === ScheduleTypeEnum.CustomDates
  ) {
    return (
      getTimeOfDayMs(schedule.startDate) < getTimeOfDayMs(schedule.endDate)
    );
  }

  return schedule.startDate.getTime() < schedule.endDate.getTime();
};
